import React from 'react';
import { PARAMS_NAME } from "../../../../config";

const Head = ({ onSortChange, params }) => {
    let th = params.map(param => {
        const paramName = PARAMS_NAME[param] ? PARAMS_NAME[param] : param;

        return <th onClick={() => onSortChange(param)} key={param}>{paramName}</th>;
    });

    return (
        <thead>
            <tr>{th}</tr>
        </thead>
    )
};

export default Head;



// WEBPACK FOOTER //
// ./src/scenes/BidderBids/components/Table/components/Head/index.js